export default "__VITE_ASSET__ChZ1G$NI__"